import { faker } from '@faker-js/faker';

import type { SignUpPostResponse } from '../types/SignUpPostResponse';

export function createSignUpPostResponse(
  data: NonNullable<Partial<SignUpPostResponse>> = {}
): NonNullable<SignUpPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
